import { Outlet } from 'react-router-dom';

const Dashboard = () => <Outlet />;

export default Dashboard;
